import {
  Button as ChordsButton,
  type ButtonSize,
  type ButtonVariant,
} from '~/chords/Button';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const Button = withClassNameHoc(ChordsButton);
export type { ButtonSize, ButtonVariant };
